<div class="overlay">
    <div class="content center-content">
        <div class="column-flex" [style.width]="data.width ? data.width : data.type == complexType ? '499px' : '415px'">
            <ng-container *ngIf="data.type == complexType">
                <div class="text-container center-content">
                    <div class="main-label">
                        <div data-cy="channels-import-download-data-version-select-modal-header">
                            {{ data.title | translate }}
                        </div>
                        <ng-container *ngIf="data.title2">
                            <div>
                                {{ data.title2 | translate }}
                            </div>
                        </ng-container>
                    </div>

                    <ng-container *ngIf="data.message">
                        <div class="message-container">
                            <div class="sub-label">
                                {{ data.message | translate }}
                            </div>
                            <ng-container *ngIf="data.message2">
                                <div class="sub-label">
                                    {{ data.message2 | translate }}
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>

                <div class="buttons-container">
                    <div
                        (click)="goBack()"
                        class="button"
                        data-cy="channels-import-download-data-version-select-cancel-button"
                        style="padding: 0px">
                        {{ data.backButton | translate }}
                    </div>

                    <div class="left-buttons">
                        <div
                            class="button discard"
                            data-cy="channels-import-download-data-version-select-complete-button"
                            (click)="discardChanges()"
                            [class.redDiscard]="data.redDiscard">
                            {{ data.discardButton | translate }}
                        </div>

                        <div
                            class="button save"
                            data-cy="channels-import-download-data-version-select-simple-button"
                            (click)="saveChanges()"
                            [class.saveDisabled]="data.saveDisabled">
                            {{ data.saveButton | translate }}
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="data.type == simpleType">
                <div class="text-container center-content">
                    <ng-container *ngIf="data.title">
                        <div class="main-label">
                            <div>
                                {{ data.title | translate }}
                            </div>
                            <ng-container *ngIf="data.title2">
                                <div>
                                    {{ data.title2 | translate }}
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <div class="message-container center-content">
                        <div
                            [ngClass]="{
                                'sub-label': data.title,
                                'sub-label-simple': !data.title,
                            }">
                            {{ data.message | translate }}
                        </div>
                        <ng-container *ngIf="data.message2">
                            <div
                                [ngClass]="{
                                    'sub-label': data.title,
                                    'sub-label-simple': !data.title,
                                }">
                                {{ data.message2 | translate }}
                            </div>
                        </ng-container>
                    </div>
                </div>

                <div class="buttons-container simple-buttons">
                    <div class="button simple-discard" (click)="discardChanges()">
                        {{ data.discardButton | translate }}
                    </div>

                    <div
                        class="button simple-confirm"
                        data-cy="alarm-group-confirmation-modal-confirm-button"
                        (click)="saveChanges()">
                        {{ data.saveButton | translate }}
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
